import React from 'react';
import styles from './styles.module.scss';
import icCloseIcon from 'assets/svg/ic_close_2.svg';
import icSuccess from 'assets/svg/ic_success_3.svg';
import Modal from 'src/Components/Modal';
import Button from 'src/Components/Button_V2';
import classNames from 'classnames';

const SuccessModal = ({
  onClose,
  onSubmit
}) => {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icCloseIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icSuccess
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Success"), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    className: classNames(styles.btn, styles.secondary),
    title: "Close",
    type: "secondary",
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Button, {
    className: styles.btn,
    title: "View my order",
    type: "primary",
    onClick: onSubmit
  }))));
};

export default SuccessModal;